import { Autocomplete, Checkbox, ListItemText, TextField, CircularProgress } from "@mui/material"
import { WidgetProps } from "@rjsf/utils"
import { collection, query, where, limit, getDocs } from "firebase/firestore"
import React from "react"
import { db } from "../firebase"
import { Business, FeaturedFormData } from "./FeaturedFormData"

export const StoresMultiSelectWidget: React.FC<WidgetProps> = (props) => {
  const { value, onChange, formContext, disabled } = props
  const formData = (formContext?.formData ?? {}) as FeaturedFormData
  const currentType = formData.type

  const [items, setItems] = React.useState<Business[]>([])
  const [loading, setLoading] = React.useState(false)
  const [search, setSearch] = React.useState("")

  const load = React.useCallback(async (term: string) => {
    setLoading(true)
    const baseRef = collection(db, "sponsors")
    const q = term
      ? query(baseRef, where("name", ">=", term), where("name", "<=", term + "\uf8ff"), limit(100))
      : query(baseRef, limit(100))

    const snap = await getDocs(q)
    const rows: Business[] = snap.docs
      .map((d) => ({ id: d.id, name: String((d.data() as any)?.name ?? d.id) }))
      .sort((a, b) => a.name.localeCompare(b.name))

    setItems(rows)
    setLoading(false)
  }, [])

  React.useEffect(() => {
    if (currentType === "Stores") load("").catch(() => setLoading(false))
  }, [currentType, load])

  if (currentType !== "Stores") return null

  const selectedIds = Array.isArray(value) ? (value as string[]) : []
  const selected = items.filter((x) => selectedIds.includes(x.id))

  const ALL_OPTION: Business = { id: "__ALL__", name: "Seleccionar todos" }
  const options: Business[] = [ALL_OPTION, ...items]

  return (
    <Autocomplete<Business, true, false, false>
      multiple
      disableCloseOnSelect
      filterSelectedOptions
      options={options}
      value={selected}
      getOptionLabel={(o) => o.name}
      onChange={(_, list) => {
        const hasAll = list.some((o) => o.id === "__ALL__")
        if (hasAll) {
          const allIds = items.map((i) => i.id)
          onChange(allIds)
          formContext?.updateFormData?.({ businessId: "", serviceId: "" })
        } else {
          const ids = list.map((o) => o.id)
          onChange(ids)
          if ((formData.businessId || formData.serviceId) && ids.length) {
            formContext?.updateFormData?.({ businessId: "", serviceId: "" })
          }
        }
      }}
      inputValue={search}
      onInputChange={(_, v) => {
        setSearch(v)
        load(v).catch(() => setLoading(false))
      }}
      renderOption={(props, option, { selected }) => {
        const allSelected = option.id === "__ALL__" && selectedIds.length === items.length && items.length > 0
        return (
          <li {...props} key={option.id}>
            <Checkbox
              checked={option.id === "__ALL__" ? allSelected : selected}
              tabIndex={-1}
              disableRipple
            />
            <ListItemText primary={option.name} />
          </li>
        )
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Seleccionar tiendas"
          variant="outlined"
          fullWidth
          disabled={disabled}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )
}
